module.exports = __webpack_public_path__ + "img/comodin-004.5ab4551d.svg";